// ── تفضيلات شاشة تحميل المتجر (لون الخلفية/النص + حركة الاسم أو اللوجو) ──────
// شاشة التحميل تُرسم قبل وصول إعدادات المتجر من Firestore، فلا يمكن قراءة الإعداد
// منها مباشرة. لذلك نخزّن التفضيلات محلياً (مثل اسم المتجر تماماً) عند كل زيارة،
// فتُستخدم في الزيارة التالية. المفتاح مربوط بالدومين — وبرقم الشركة أيضاً على
// دومين المنصّة (‎/store/<cid>‎) كي لا تختلط تفضيلات شركة بأخرى على نفس المتصفّح.

export const LOADER_DEFAULTS = {
  bg: "#ffffff",
  color: "#607878",
  anim: "erase",   // erase | write | none | logo
  logo: "",        // لوجو الهيدر (إنجليزي) — يُستخدم في وضع "logo"
  logoAr: "",      // لوجو الهيدر (عربي)
  logoSize: 72,
  dotsGap: 22,     // المسافة بين اللوجو والنقاط (تقبل السالب لتقريبها من لوجو فيه فراغ شفاف)
};
export const LOADER_ANIMS = ["erase", "write", "none", "logo"];

const isHex = (v) => typeof v === "string" && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v.trim());
const asUrl = (v) => (typeof v === "string" && v.length < 2048) ? v : "";

export function loaderKey(cid) {
  const host = window.location.hostname;
  return `bkv_ldr_${host}${cid ? "_" + cid : ""}`;
}

export function readLoaderPrefs(cid) {
  try {
    const p = JSON.parse(localStorage.getItem(loaderKey(cid)) || "null") || {};
    const size = parseInt(p.logoSize, 10);
    const gap  = parseInt(p.dotsGap, 10);
    return {
      bg:     isHex(p.bg)    ? p.bg.trim()    : LOADER_DEFAULTS.bg,
      color:  isHex(p.color) ? p.color.trim() : LOADER_DEFAULTS.color,
      anim:   LOADER_ANIMS.includes(p.anim)   ? p.anim : LOADER_DEFAULTS.anim,
      logo:   asUrl(p.logo),
      logoAr: asUrl(p.logoAr),
      logoSize: size >= 24 && size <= 200 ? size : LOADER_DEFAULTS.logoSize,
      dotsGap:  Number.isFinite(gap) && gap >= -80 && gap <= 80 ? gap : LOADER_DEFAULTS.dotsGap,
    };
  } catch { return { ...LOADER_DEFAULTS }; }
}

export function saveLoaderPrefs(cid, prefs) {
  try { localStorage.setItem(loaderKey(cid), JSON.stringify(prefs)); } catch {}
}

// لوجو شاشة التحميل حسب لغة الزائر (يرجع للّغة الأخرى إن لم يوجد)
export function loaderLogo(prefs, lang) {
  return lang === "ar" ? (prefs.logoAr || prefs.logo) : (prefs.logo || prefs.logoAr);
}

// CSS النقاط الثلاث (نفس حركة شاشة تحميل لوحة التحكم)
export const loaderDotsCss = (color) =>
  `.ldr-dot{width:8px;height:8px;border-radius:50%;background:${color};opacity:.35;animation:ldrDot 1.1s ease-in-out infinite}` +
  `.ldr-dot:nth-child(2){animation-delay:.18s}.ldr-dot:nth-child(3){animation-delay:.36s}` +
  `@keyframes ldrDot{0%,100%{opacity:.25;transform:translateY(0)}40%{opacity:1;transform:translateY(-5px)}}`;
